<template>
  <div class="about">
    <div class="banner1">
      <div class="desc">
        <h3 class="title">{{ $t('desc2') }}</h3>
        <p class="slogan">{{ $t('slogan') }}</p>
      </div>
    </div>
    <div class="aboutus">
      <p class="aboutTitle">{{ $t('nav5') }}</p>
      <div class="info">
        <div class="box">
          <p>{{ $t('about1') }}</p>
          <p>{{ $t('about2') }}</p>
          <p>{{ $t('about3') }}</p>
        </div>
      </div>
    </div>
    <div class="mission">
      <p class="aboutTitle">{{ $t('mission') }}</p>
      <div class="desc">
        <div class="img"><img src="../assets/mission.jpg" alt="" /></div>
        <div class="info">
          <p>{{ $t('mission2') }}</p>
          <p>{{ $t('mission3') }}</p>
          <p>{{ $t('mission4') }}</p>
        </div>
      </div>
    </div>
    <Platform />
  </div>
</template>
<script>
import Platform from '@/components/Platform.vue'
export default {
  components: { Platform }
}
</script>
<style lang="scss" scoped>
.about {
  background: #fff;
}
.banner1 {
  height: 43vw;
  background: url(../assets/banner.jpg) no-repeat center center;
  position: relative;
  background-size: cover;
  .desc {
    position: absolute;
    left: 4.4vw;
    top: 4.4vw;
    width: 67.7vw;
    height: 28vw;
    border-radius: 10px;
    background: rgba($color: #473f71, $alpha: 0.2);
    box-shadow: 0 0 30px rgba($color: #473f71, $alpha: 0.4);
    color: #fff;
    font-weight: bold;
  }
  .title {
    font-size: 3.4vw;
    padding: 6.25vw 40px 0;
    text-shadow: 6px 0 10px #1e183d, 6px 0 16px #1e183d;
  }
  .slogan {
    padding: 3vw 6.8vw 0 25vw;
    font-size: 1.9vw;
    line-height: 1.8;
    text-shadow: 3px 4px 10px #251b58, 3px 4px 18px #251b58;
  }
}
.aboutTitle {
  text-align: center;
  width: 230px;
  margin: 40px auto;
  font-weight: bold;
  font-size: 20px;
  color: #232325;
  border-bottom: 9px solid #99b4a1;
  position: relative;
  line-height: 48px;
}
.aboutus {
  overflow: hidden;
  padding-bottom: 30px;
  .info {
    position: relative;
    height: 555px;
    width: 1100px;
    margin: 0 auto;
    &:before {
      content: '';
      position: absolute;
      bottom: 0;
      right: 0;
      left: 20px;
      top: 16px;
      background: #99b4a1;
    }
  }
  .box {
    position: absolute;
    left: 0;
    top: 0;
    right: 35px;
    bottom: 27px;
    background: #66cccc;
    box-shadow: 0 0 30px #fff;
    padding: 20px 36px;
    font-size: 16px;
    color: #11123a;
    line-height: 2;
    word-break: normal;
    p {
      margin-bottom: 30px;
    }
  }
}
.mission {
  .desc {
    overflow: hidden;
    width: 1100px;
    margin: 80px auto;
    border-radius: 10px;
    background: #66cccc;
  }
  .img {
    float: right;
    font-size: 0;
  }
  .info {
    overflow: hidden;
    padding: 100px 50px 0;
    font-size: 16px;
    line-height: 40px;
    color: #001d48;
    p {
      padding: 8px 0;
      font-size: 20px;
    }
  }
}
</style>
<style lang="scss" scoped>
@media screen and (max-width: 768px) {
  .banner1 .title{
    padding: 6.25vw 0 0;
  }
  .aboutTitle {
    margin: 0 auto;
    margin-bottom: 20px;
  }
  .banner1 {
    .desc {
      width: auto;
    }
    .title,
    .slogan {
      font-size: 4vw;
    }
    .slogan{
      padding-left: 0;
      padding-right: 60px;
    }
  }
  .aboutus {
    overflow: inherit;
    padding-bottom: 0px;
    .box {
      position: relative;
    }
    .info {
      width: 100%;
      height: auto;
      min-height: 555px;
    }
  }
  .platform {
    padding: 0;
    padding-top: 20px;
  }
  .mission {
    margin-top: 10px;
    padding: 0 10px;
    .desc {
      width: 100%;
      margin: 0 auto;
      margin-top: 20px;
      .img {
        width: 100%;
        float: inherit;
        img {
          width: 100%;
          height: auto;
        }
      }
      .info {
        // text-align: center;
        p {
          padding: 4px 0;
          font-size: 16px;
        }
        padding: 24px;
        line-height: 20px;
      }
    }
  }
}
</style>
<i18n>
{
  "cn": {
    "slogan": "用一个生命影响另一个生命",
    "desc2": "一对一教育",
    "about1": "牛剑学术是一家以卓越学术为核心的教育机构，以一个私人俱乐部形式营运的在线教育平台，供导师、学生和学者们自由地相遇及交流。在这里，大家可以轻松、高效及方便地编排课堂或学习研讨。 我们所有的导师都拥有英国牛津大学或剑桥大学（简称“Oxbridge”）的学术背景，这表明了我们对卓越学术追求的文化。 我们所有的导师均是 Oxbridge 现任研究生，Oxbridge 毕业生，Oxbridge 博士后或这两所世界闻名大学的讲师及教授。",
    "about2": "凭着广阔的 Oxbridge 导师网络，我们的目标是为就读 A-level 或 IB 课程的学生提供最佳的在线一对一个人辅导式教学，适合不同学习能力及水平的学生。无论您是在寻找一位专家来帮助您弥补学习知识上的缺漏，协助您完善一项专题研究或拓展论文，练习专门针对考试的技巧，或者是撰写申请大学的个人陈述，我们的导师都会根据您的个人需要来设计并编排每一堂课，以帮助您达成目标。透过使用个性化的方法，互动力强的练习，以及我们开发的教学工具，我们的导师将致力达到每一堂课都是一次有益而富有成效的体验。",
    "about3": "在牛剑学术，我们深信我们的专家导师团队 -- 他们是世界上最顶尖的学术群组之一 -- 将致力打造好比在牛津及剑桥大学同样具有全方位支持但亦富有极具挑战性的学习环境，激励我们的学生超越界限，实现梦想。",
    "mission": "愿景和使命",
    "mission2": "借助互联网力量，",
    "mission3": "继承传统教育成果，",
    "mission4": "推动个性化教育普及。"
  },
  "TW": {
    "slogan": "用一個生命影響另一個生命",
    "desc2": "一對一教育",
    "about1": "牛劍學術是一家以卓越學術為核心的教育機構，以一個私人俱樂部形式營運的線上教育平台，供導師、學生和學者們自由地相遇及交流。在這裡，大家可以輕鬆、高效率及方便地編排課堂或學習研討。我們所有的導師都擁有英國牛津大學或劍橋大學（簡稱 “Oxbridge”）的學術背景，表明了我們對卓越學術追求的文化。我們所有的導師均是 Oxbridge 現任研究生，Oxbridge 畢業生，Oxbridge 博士後或這兩所世界聞名大學的講師及教授。",
    "about2": "憑著強大的 Oxbridge 導師網絡，我們的目標是為就讀 A-level 或 IB 課程的學生提供最佳的線上一對一個人輔導教學，適合不同學習能力及水平的學生。無論您是在尋找一位專家來幫助您彌補學習知識上的缺漏，協助您完善一項專題研究或拓展論文，練習針對考試的技巧，或者是撰寫申請大學的個人陳述，我們的導師都會根據您的個人需要來設計並編排每一堂課，以幫助您達成目標。透過使用個性化的方法，互動力強的練習，以及我們開發的教學工具，我們的導師將致力達到每一堂課都是一次有益而富有成效的體驗。",
    "about3": "在牛劍學術，我們深信我們的專家導師團隊 -- 他們是世界上最頂尖的學術群組之一 -- 將致力打造好比在牛津及劍橋大學同樣具有全方位支持但亦富有極具挑戰性的學習環境，啟發我們的學生超越界限，實現夢想。",
    "mission": "願景和使命",
    "mission2": "借助互聯網力量，",
    "mission3": "繼承傳統教育成果，",
    "mission4": "推動個性化教育普及。"
  },
  "en": {
    "slogan": "To have one bright academic mind leading and guiding the next. ",
    "desc2": "One-to-One Personal Education",
    "about1": "Newton Academic Tuition (\"Newton\") is first and foremost a centre for academic excellence, an online platform for tutors, students and academics to mingle freely and arrange tutorials and study seminars with ease, efficiency and convenience – rather like a virtual private members' club. The calibre of our tutors, who all have Oxford and Cambridge (\"Oxbridge\") backgrounds themselves, testify to this culture: all our tutors are either current postgraduates, graduates, postdoctorates, lecturers or professors from one of these two world-famous universities. ",
    "about2": "With our extensive network of Oxbridge tutors, we provide online one-to-one tutorial guidance to students of all abilities who pursue the A-level or the IB curriculum. Whether you are looking for a subject expert to bridge a learning gap, to help with a piece of extended research, to practise exam-oriented drills, or to prepare for personal statements, our tutors will tailor each lesson to your individual needs to help you reach your goals. Using personalised methods and interactive exercises as well as teaching tools developed by us, our tutors are dedicated in making each lesson a rewarding and productive experience.",
    "about3": " At Newton, we believe our team of dedicated experts, who are amongst some of the brightest academic minds in the world, would help foster the same kind of supportive yet challenging learning environment as at Oxford and Cambridge, inspiring our students to push beyond boundaries and achieve their dreams.",
    "mission": "OUR MISSION",
    "mission2": "Harnessing the power of the internet,",
    "mission3": "we aim to universally promote one-to-one customised learning,",
    "mission4": "with all the virtues of traditional education at the very heart of all that we do."
  }
}
</i18n>